import { jsx as _jsx } from "react/jsx-runtime";
import Button from '../../Button';
import { Box } from '@kolmeo/ui-core';
const ModalFooter = ({ actions }) => {
    return (_jsx(Box, { flexDirection: 'row', paddingY: 16, justifyContent: "space-between", children: actions.map(({ label, action, variant }) => _jsx(Box, { flexBasis: '48%', children: _jsx(Button, { buttonText: label, onPress: action, variant: variant }) })) }));
};
export default ModalFooter;
